// src/utils/api/corsConfig.ts

import config from '../../config';

//export const corsConfig = {
//    credentials: 'include' as const,
//    headers: {
//        'Accept': 'application/json',
//        'Content-Type': 'application/json',
//        'X-Requested-With': 'XMLHttpRequest',
//        'Origin': window.location.origin,
//        'Access-Control-Allow-Origin': config.API_URL
//    },
//    mode: 'cors' as const
//};

export const corsConfig = {
    credentials: 'include' as const,  // Keep credentials mode
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
    },
    mode: 'cors' as const
};


// Helper to check if a response has CORS error
export const isCORSError = (error: Error): boolean => {
    return error instanceof TypeError &&
        (error.message.includes('CORS') || error.message.includes('cross-origin'));
};

// Helper to create CORS-safe request options
export const createCORSRequestOptions = (
    options: RequestInit = {}
): RequestInit => {
    return {
        ...corsConfig,
        ...options,
        headers: {
            ...corsConfig.headers,
            ...(options.headers || {})
        }
    };
};

// Helper to detect and handle preflight responses
export const handlePreflightResponse = (response: Response): boolean => {
    if (response.type === 'opaque' || response.status === 204) {
        // This is likely a preflight response
        return true;
    }
    return false;
};

